import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const TimesIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path d="m9.487 8 3.367-3.366a.5.5 0 0 0 0-.706l-.783-.782a.5.5 0 0 0-.705 0L8 6.513 4.634 3.146a.5.5 0 0 0-.706 0l-.782.782a.5.5 0 0 0 0 .706L6.512 8l-3.366 3.366a.5.5 0 0 0 0 .706l.782.782a.5.5 0 0 0 .706 0L8 9.488l3.366 3.366a.5.5 0 0 0 .706 0l.782-.782a.5.5 0 0 0 0-.706z" />
  </svg>
);
TimesIcon.displayName = 'TimesIcon';
export default TimesIcon;
